import { render, staticRenderFns } from "./Notizenliste.vue?vue&type=template&id=05f869c0&"
import script from "./Notizenliste.vue?vue&type=script&lang=js&"
export * from "./Notizenliste.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports